import { ROTULO_PERFIL, type Canal, type Eu } from "@horofacial/shared";
import { clsx } from "clsx";
import { Bell, ChevronDown, ChevronsUpDown, Plus } from "lucide-react";

/*
 * Botões da casca que abrem menus (Novo, Avisos, Usuário). O menu em si (Radix) vem num arquivo carregado logo
 * depois da primeira tela (MenusCasca); até lá a casca mostra estes mesmos botões, com o mesmo visual.
 * Aqui não entra Radix nem tailwind-merge: este arquivo faz parte do carregamento inicial.
 */

export const classeIcone =
  "relative inline-flex size-9 shrink-0 items-center justify-center rounded-[var(--raio)] text-muted-foreground outline-none transition-colors hover:bg-accent hover:text-foreground focus-visible:ring-[3px] focus-visible:ring-ring/40 data-[state=open]:bg-accent pointer-coarse:size-11 [&_svg]:size-4";

export const classeNovo =
  "ml-1 inline-flex h-8 shrink-0 items-center justify-center gap-2 rounded-[var(--raio)] bg-primary px-3 text-[13px] font-medium whitespace-nowrap text-primary-foreground shadow-[var(--sombra-xs)] outline-none transition-colors hover:bg-marca-forte focus-visible:ring-[3px] focus-visible:ring-ring/40 pointer-coarse:h-10 [&_svg]:size-4";

export const classeUsuario = (comNome: boolean) =>
  clsx(
    "flex min-h-12 w-full items-center gap-2.5 rounded-[var(--raio)] p-1.5 text-left outline-none hover:bg-accent focus-visible:ring-[3px] focus-visible:ring-ring/40 data-[state=open]:bg-accent",
    !comNome && "justify-center",
  );

export const rotuloAvisos = (caidos: Canal[]) => (caidos.length ? `Avisos: ${caidos.length}` : "Avisos");
export const rotuloUsuario = (eu: Eu) => `${eu.usuario.nome}: conta, aparência e sair`;

export function ConteudoAvisos({ caidos }: { caidos: Canal[] }) {
  return (
    <>
      <Bell />
      {caidos.length > 0 && <span className="absolute top-2 right-2 size-2 rounded-full bg-perigo ring-2 ring-fundo" aria-hidden />}
    </>
  );
}

export function ConteudoNovo() {
  return (
    <>
      <Plus />
      <span className="hidden sm:inline">Novo</span>
      <ChevronDown className="hidden opacity-70 sm:block" />
    </>
  );
}

export function ConteudoUsuario({ eu, comNome }: { eu: Eu; comNome: boolean }) {
  return (
    <>
      <Iniciais nome={eu.usuario.nome} />
      {comNome && (
        <>
          <span className="min-w-0 flex-1 leading-tight">
            <span className="block truncate text-[13px] font-semibold">{eu.usuario.nome}</span>
            <span className="block truncate text-xs text-muted-foreground">{ROTULO_PERFIL[eu.usuario.perfil]}</span>
          </span>
          <ChevronsUpDown className="size-4 text-muted-foreground" aria-hidden />
        </>
      )}
    </>
  );
}

function Iniciais({ nome }: { nome: string }) {
  const ini = nome
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]!.toUpperCase())
    .join("");
  return (
    <span className="grid size-8 shrink-0 place-items-center rounded-full bg-muted text-xs font-semibold" aria-hidden>
      {ini}
    </span>
  );
}
